export const FULL_PAGE_KEY = '28540A01-5BC941F3-A60B01BA-75084724'
export const FULLPAGE_DISABLED_UNDER_WIDTH = '680'
export const FULLPAGE_DISABLED_UNDER_HEIGHT = '680'

export const COPYRIGHT = '&copy; ' + new Date().getFullYear() + ' finCraft AG - Alle Rechte vorbehalten'
